var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"products"},[_vm._m(0),_c('hr'),_c('FormProducts',{attrs:{"_product":_vm.product},on:{"store":_vm.store}}),_c('LoadingComponent',{attrs:{"loading":_vm.loading}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('h1',{staticClass:"fw-600 fs-24 mb-0"},[_vm._v("Adicionar Produto")])])])
}]

export { render, staticRenderFns }